import React from "react";
import { Constants } from "../utils/constants";

const HAvatar = ({ src, alt, className, style }) => {
  const defaultStyle = {
    border: `2px solid ${Constants.HOST_EXPERIENCE_BASE_COLOR}`,
  };

  const mergedStyle = { ...defaultStyle, ...style };

  return (
    <div className={`overflow-hidden rounded-full ${className || "h-10 w-10"}`} style={mergedStyle}>
      <img
        src={src || "/placeholder.svg"}
        alt={alt}
        className="h-full w-full object-cover"
        onError={e => {
          e.target.onerror = null;
          e.target.src = `https://ui-avatars.com/api/?name=${encodeURIComponent(alt)}&background=random`;
        }}
      />
    </div>
  );
};

export default HAvatar;
